import React from 'react'
import NextIcon from '../../../../components/svg/next-circle'
import Link from 'next/link'
import { useRouter } from 'next/router'

const LabelCard = ({ icon, title, description, enabled, href }) => {
  const Wrapper = ({ children, href }) =>
    enabled ? (
      <Link legacyBehavior href={href}>
        <a>{children}</a>
      </Link>
    ) : (
      <div>{children}</div>
    )

  return (
    <Wrapper href={href}>
      <div className='root'>
        <div className='icon'>{icon}</div>
        <div className='content'>
          <h3 className='title'>{title}</h3>
          <p className='description'>{description}</p>
          {enabled && (
            <div className='action-icon'>
              <NextIcon />
            </div>
          )}
        </div>
        <style jsx>{`
          .disabled-link {
            pointer-events: none;
          }

          .root {
            display: flex;
            position: relative;
            width: 100%;
            height: 100%;
            padding: 3rem 2.5rem;
            background: var(--secondary-bg-color);
            box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
            border-radius: 1rem;

            .content {
              width: 100%;
              padding-left: 1.7rem;
              color: #fff;

              .title {
                font-size: 3.2rem;
                line-height: 3.2rem;
                padding-bottom: 0.5rem;
              }

              .description {
                font-size: 1.8rem;
                padding-right: 3.5rem;
                color: var(--secondary-text-color);
              }
            }

            .icon :global(svg) {
              fill: #0c77ee;
              opacity: 0.5;
            }

            .action-icon {
              position: absolute;
              right: 2.5rem;
              bottom: 2.5rem;
            }
          }

          @media (max-width: 1200px) {
            .root {
              .icon {
                :global(svg) {
                  width: 3.5rem;
                  height: 3.5rem;
                }
              }
              .content {
                .title {
                  font-size: 2.8rem;
                  line-height: 2.8rem;
                }
                .description {
                  font-size: 1.6rem;
                }
              }
              .action-icon {
                :global(svg) {
                  width: 2.5rem;
                  height: 2.5rem;
                }

                right: 2rem;
                bottom: 2rem;
              }
            }
          }

          @media (max-width: 1024px) {
            .root {
              .icon {
                :global(svg) {
                  width: 3rem;
                  height: 3rem;
                }
              }
              .content {
                padding-left: 1rem;

                .title {
                  font-size: 2rem;
                  line-height: 2rem;
                }

                .description {
                  font-size: 1.4rem;
                }
              }

              .action-icon {
                :global(svg) {
                  width: 2rem;
                  height: 2rem;
                }

                right: 1.5rem;
                bottom: 1.5rem;
              }
            }
          }
        `}</style>
        <style jsx>{`
          .root {
            cursor: ${enabled ? 'pointer' : 'not-allowed'};
          }
        `}</style>
      </div>
    </Wrapper>
  )
}

export default LabelCard
